import React from "react";

const items = [
  "Ação Penal 470",
  "Operação Lava Jato",
  "Triplex do Guarujá",
  "Sítio de Atibaia",
  "Petrobras",
  "BNDES",
  "Impeachment 2016",
  "Autos Processuais",
  "Mensalão",
  "Pacote Político",
];

export default function Marquee() {
  const line = items.concat(items);
  return (
    <section className="relative border-y border-white/5 bg-black overflow-hidden py-6 md:py-8">
      <div className="marquee font-display italic text-neutral-500 text-3xl md:text-5xl">
        {line.map((t, i) => (
          <span key={i} className="inline-flex items-center gap-10">
            <span>{t}</span>
            <span className="text-red-600">✱</span>
          </span>
        ))}
      </div>
    </section>
  );
}
